export enum TabType {
	Interactions,
	History,
	Voicemail,
	Supervisor,
	SupervisorInteractions,
}

export enum ToggleTabType {
	Contacts,
	Resources,
	Statistics,
	NewInteraction,
}

export interface NavigationState {
	activeInteractionsCount: number;
	selectedTab: TabType;
	toggledTab?: ToggleTabType;
	isMobileDetailViewMode: boolean;
}

export interface NavigationActions {
	updateActiveInteractionsCount: (value: number) => void;
	setSelectedTab: (tab: TabType) => void;
	setToggledTab: (tab?: ToggleTabType) => void;
	setIsMobileDetailViewMode: (isMobileDetailViewMode: boolean) => void;
}
